export default [
    {
        // [0]
        key: "employee_id",
        label: "Employee",
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "area",
        label: "AREA",
        visible: true,
    },
    {
        // [1]
        key: "cargo",
        label: "Cargo",
        visible: true,
    },
    {
        // [1]
        key: "status",
        label: "Status",
        visible: true,
    },
    {
        // [1]
        key: "sueldo_base_anterior",
        label: "Sueldo anterior",
        visible: true,
    },
    {
        // [1]
        key: "bono_anterior",
        label: "Bono anterior",
        visible: true,
    },
    {
        // [1]
        key: "nuevo_sueldo_base",
        label: "Nuevo sueldo",
        visible: true,
    },
    {
        // [1]
        key: "nuevo_bono",
        label: "Nuevo bono",
        visible: true,
    },
    {
        // [1]
        key: "fecha_vigencia",
        label: "Fecha vigencia",
        visible: true,
    },
    {
        // [4]
        key: "created_by",
        label: "Created By",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "created_at",
        label: "Created At",
        sortable: true,
        visible: true,
    },
    {
        // [5]
        key: "observacion",
        label: "Observation",
        visible: true,
    },
    {
        // [5]
        key: "observacion_gerencia",
        label: "Observation gerencia",
        visible: true,
    },
    {
        // [6]
        key: "actions",
        label: "Actions",
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
]